import { render, staticRenderFns } from "./BillingAll.vue?vue&type=template&id=9520a060&lang=html&"
import script from "./BillingAll.vue?vue&type=script&lang=js&"
export * from "./BillingAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports